/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsnoage2Inputs */

const en_signupsnoage2 = /** @type {(inputs: Signupsnoage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No birth dates set in this window.`)
};

const de_signupsnoage2 = /** @type {(inputs: Signupsnoage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Geburtsdaten in diesem Zeitraum.`)
};

/**
* | output |
* | --- |
* | "No birth dates set in this window." |
*
* @param {Signupsnoage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsnoage2 = /** @type {((inputs?: Signupsnoage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsnoage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsnoage2(inputs)
	return de_signupsnoage2(inputs)
});
export { signupsnoage2 as "signupsNoAge" }